export const assertions = {
  email(value, message = 'Invalid email') {
    if (!String(value).match(/^([\w.%+\-']+)@([\w-]+\.)+([\w]{2,})$/)) {
      throw Error(message)
    }
  },

  notEmpty(value, message = 'Required') {
    if (value && value.trim) {
      value = value.trim()
    }

    if (!value) {
      throw Error(message)
    }
  },

  required(value, message = 'Required') {
    if (value && value.trim) {
      value = value.trim()
    }

    if (!value) {
      throw Error(message)
    }
  },
}

export default assertions



// WEBPACK FOOTER //
// ./src/utils/assertions.js